import readlangClient from "./readlangClient";

const StripeCustomer = function (callback) {
  readlangClient.request(
    "GET",
    "/api/stripe/defaultPaymentMethod",
    {},
    (response) => {
      this.defaultPaymentMethod = response;
      console.log("default payment method: ", response);
      callback();
    },
    (error) => {
      if (error.status === 404) {
        this.noStripeCustomer = true;
      }
      console.log("no default payment method: ", error);
      callback();
    }
  );
};

StripeCustomer.prototype.getDefaultCard = function () {
  return this.defaultPaymentMethod;
};

StripeCustomer.prototype.setPlan = function (plan, callback) {
  readlangClient.request(
    "POST",
    "/api/stripe/updateSubscription",
    {
      plan,
    },
    function (response) {
      console.log("updated subscription: ", response);
      callback();
    },
    function (error) {
      callback(error);
    }
  );
};

StripeCustomer.prototype.createSubscription = function (
  plan,
  subscriptionExpiryDate, // As a Date object
  callback
) {
  readlangClient.request(
    "POST",
    "/api/stripe/subscription",
    {
      plan,
      trialEnd: Math.round(subscriptionExpiryDate.getTime() / 1000),
    },
    function (response) {
      console.log("created subscription: ", response);
      callback();
    }
  );
};

StripeCustomer.prototype.removeSubscription = function (callback) {
  readlangClient.request("DELETE", "/api/stripe/subscription", {}, function () {
    callback();
  });
};

export default StripeCustomer;
